<template>
  <div class="df-telephone">
    <DfHeader :error="error" :text="schema.label" />
    <NsPhoneNumber
      v-model="model"
      class="df-telephone__input"
      :label="schema.label"
      :country="localeCountry"
      :hint="schema.hint"
      :required="schema.required"
      :error-message="requiredErrorMessage"
      @update:error="receiveError"
    />
  </div>
</template>

<script>
/**
 * Original Author: Aaron Turnblom
 * Original Team: Area 51
 */
import DfHeader from '../common/df-header.vue';
import NsPhoneNumber from '../../NsPhoneNumber.vue';

import { LocaleMixin, PropsMixin, RulesMixin, ModelMixin } from '../mixins';

export default {
  name: 'NsInputTelephoneField',
  components: {
    DfHeader,
    NsPhoneNumber,
  },
  mixins: [LocaleMixin, PropsMixin, RulesMixin, ModelMixin({ deep: true })],
  props: {
    /**
     * Field value
     * @type {object}
     */
    value: {
      type: Object,
      default: () => ({ country: '', number: '' }),
    },
  },
  data() {
    return {
      error: false,
    };
  },
  methods: {
    receiveError(error) {
      this.error = error;
    },
  },
};
</script>

<style lang="scss" scoped>
.df-telephone__input {
  width: 100%;
}

.df-telephone {
  margin-top: 15px;
}
</style>
